export const URLS: { [key: string]: any } = {
  auth: 'auth',
  roles: 'roles',
  admins: 'admins',
  carousels: 'carousels',
  logout: 'logout',
  refreshTokens: 'auth/refresh_tokens',
  brands: 'brands',
  stores: 'stores',
  collections: 'collections',
  currencies: 'currencies',
  items: 'items',
  salesRevenue: 'sales/get_revenue',
  serviceHealth: 'service_health',

  // dashboard start
  scalars: 'dashboard/scalars',
  royalties: 'dashboard/royalties',
  timeseries: 'dashboard/timeseries',
  usersReg: 'dashboard/registrations/timeseries',
  usersRegCount: 'dashboard/registrations/count',
  efficiency: 'dashboard/efficiency',
  balances: 'dashboard/balances',
  // dashboard end

  ban: 'ban',
  unban: 'unban',
  users: 'users',
  userDetail: 'users/<id>',
  userDetailBalances: 'users/<id>/balances',
  userDetailNft: 'users/<id>/nft',
  userNfts: 'users/<id>/nfts',
  giveaway: 'items/<id>/giveaway',
  loginBanner: 'login_banners',
  coupons: 'coupons',
  couponsNames: 'coupons/generate_names',
};

export const baseUrl = `${process.env.REACT_APP_API_DOMAIN}/api/v1/`;
